module.exports = __webpack_public_path__ + "img/learn.2852038a.png";